<div
  class="star-review"
  (mouseleave)="onLeave()"
  role="radiogroup"
  aria-label="Rating"
>
  @for (index of icons(); track index) {
    <button
      type="button"
      class="star-review__item"
      [attr.aria-label]="'Rate ' + index + ' out of ' + amount()"
      [attr.aria-checked]="index === rating()"
      [disabled]="isDisabled() || undefined"
      role="radio"
      (mouseenter)="onHover(index)"
      (click)="onSelect(index)"
    >
      <umss-icon
        [name]="iconFor(index)"
        [size]="iconSize()"
        [color]="colorFor(index)"
      />
    </button>
  }
</div>
